import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgFacebookFill = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="-.5 -.5 16 16"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8.75 8.4375h1.5625l.625-2.5H8.75v-1.25c0-.6434 0-1.25 1.25-1.25h.9375v-2.1c-.2036-.027-.9731-.0875-1.7857-.0875C7.4552 1.25 6.25 2.2855 6.25 4.1873v1.7502H4.375v2.5H6.25V13.75h2.5z" />
  </svg>
);
export default SvgFacebookFill;
